import useApiMutation from 'shared/hooks/use-api-mutation';
import useQueryHelpers from 'shared/hooks/use-query-helpers';
import {CompanyProps} from '../types';
import companiesKeys from '../util/companies-keys';

const useEditWorkingPeriod = (id: string) => {
  const {setData} = useQueryHelpers();

  const onSuccess = (data: CompanyProps) => {
    setData(companiesKeys.details(id), data);
  };

  return useApiMutation({
    url: `/companies/${id}/working-period`,
    method: 'PATCH',
    errorTitle: 'Erro ao editar empresa',
    successTitle: 'Editar empresa',
    successMessage: 'Empresa atualizada com sucesso',
    redirectUrl: `/settings/companies/${id}/working-periods`,
    onSuccess,
  });
};

export default useEditWorkingPeriod;
